/** @format */

import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'dashboard.title',
    link: '/dashboard',
  },
  {
    id: 2,
    label: 'member-manage.title',
    link: '/member-manage',
  },
  {
    id: 43,
    label: 'membership-manage.title',
    link: '/membership-manage',
  },
  {
    id: 3,
    label: 'feed-manage.feedManage',
    link: '/feed-manage',
  },
  {
    id: 4,
    label: 'shop.shopTitle',
    link: '/shop-new',
  },
  {
    id: 5,
    label: 'grade-curriculum.educationManagement',
    subItems: [
      {
        id: 6,
        label: 'grade-curriculum.gradeCurriculum',
        link: '/grade-curriculum',
        parentId: 5,
      },
      {
        id: 7,
        label: 'poomsae-manage.poomsaeCheck',
        link: '/poomsae-manage',
        parentId: 5,
      },
      {
        id: 8,
        label: 'monthly-personality.monthlyPersonality',
        link: '/monthly-personality',
        parentId: 5,
      },
    ],
  },
  {
    id: 9,
    label: 'affiliate.applyManage',
    subItems: [
      {
        id: 10,
        label: 'affiliate.applyAffiliate',
        link: '/affiliate',
        parentId: 9,
      },
      {
        id: 11,
        label: 'sports-facilities.FacilityCertificationApplication2',
        link: '/sports-facilities',
        parentId: 9,
      },
      // {
      //   id: 9,
      //   label: 'affiliate.affiliateApplication',
      //   link: '/v',
      //   parentId: 6,
      // },
      // {
      //   id: 4,
      //   label: '인증시설 신청',
      //   link: '/authorized-manage',
      //   parentId: 3,
      // },
    ],
  },
  {
    id: 12,
    label: 'all-facilities-manage.facilityManagement',
    subItems: [
      {
        id: 13,
        label: 'all-facilities-manage.title',
        link: '/all-facilities-manage',
        parentId: 12,
      },
      // {
      //   id: 8,
      //   label: 'affiliate-facilities-manage.title',
      //   link: '/affiliate-facilities-manage',
      //   parentId: 12,
      // },
      {
        id: 14,
        label: 'authorized-facilities-manage.facilityManage',
        link: '/authorized-facilities-manage',
        parentId: 12,
      },
      {
        id: 15,
        label: 'message.messageHistory',
        link: '/message',
        parentid: 12,
      },
    ],
  },
  {
    id: 16,
    label: 'notice.notice',
    subItems: [
      {
        id: 17,
        label: 'notice.notice',
        link: '/notice',
        parentId: 16,
      },
      // TODO
      {
        id: 18,
        label: 'ad.jobAd',
        link: '/ad',
        parentId: 16,
      },

      {
        id: 19,
        label: 'FAQ',
        link: '/faq',
        parentId: 16,
      },
    ],
  },
  {
    id: 20,
    label: 'facility-class-detail.paymentManagement',
    subItems: [
      {
        id: 21,
        label: 'facility-class-detail.facilityClassDetails',
        link: '/facility-class-detail',
        parentId: 20,
      },
      {
        id: 23,
        label: 'membership-payment-detail.paymentDetail',
        link: '/membership-payment-detail',
        parentId: 20,
      },
      {
        id: 22,
        label: 'exchange-detail.exchangeDetail',
        link: '/exchange-detail',
        parentId: 20,
      },
      {
        id: 24,
        label: 'exchange-detail.canceledLesson',
        link: '/canceled-lesson-list',
        parentId: 20,
      },
    ],
  },
  {
    id: 24,
    label: 'point.point',
    subItems: [
      {
        id: 25,
        label: 'point.pointGiven',
        link: '/point',
        parentId: 24,
      },
      {
        id: 26,
        label: 'point-detail.pointDetails',
        link: '/point-detail',
        parentId: 24,
      },
    ],
  },
  {
    id: 27,
    label: 'info-manage.serviceManagement',
    subItems: [
      {
        id: 28,
        label: 'info-manage.infoManage',
        link: '/info-manage',
        parentId: 27,
      },
      {
        id: 28,
        label: '포인트 설정',
        link: '/service-setting',
        parentId: 27,
      },
      {
        id: 29,
        label: 'company-info.companyInfo',
        link: '/company-info',
        parentId: 27,
      },
      {
        id: 30,
        label: 'tutorial.tutorial',
        link: '/tutorial',
        parentId: 27,
      },
      {
        id: 31,
        label: 'qr-design.qrDesign',
        link: '/qr-design',
        parentId: 27,
      },
    ],
  },
  {
    id: 32,
    label: 'facility-report.reportManage',
    subItems: [
      {
        id: 32,
        label: 'user-report-management.title',
        link: '/user-report-management',
      },
      {
        id: 33,
        label: 'reply-report-management.title',
        link: '/reply-report-management',
      },
      {
        id: 34,
        label: 'review-report-management.title',
        link: '/review-report-management',
      },
      {
        id: 33,
        label: 'facility-report.studioReport',
        link: '/facility-report',
        parentId: 32,
      },
      {
        id: 34,
        label: 'feed-report.feedReport',
        link: '/feed-report',
        parentId: 32,
      },
      {
        id: 35,
        label: 'ad-report.jobAd',
        link: '/ad-report',
        parentId: 32,
      },
    ],
  },

  // {
  //   id: 31,
  //   label: 'user-report-management.topTitle',
  //   subItems: [
  //     {
  //       id: 32,
  //       label: 'user-report-management.title',
  //       link: '/user-report-management',
  //     },
  //     {
  //       id: 33,
  //       label: 'reply-report-management.title',
  //       link: '/reply-report-management',
  //     },
  //     {
  //       id: 34,
  //       label: 'review-report-management.title',
  //       link: '/review-report-management',
  //     },
  //   ],
  // },
  // {
  //   id: 24,
  //   label: 'notice.customerService',
  //   subItems: [
  //     {
  //       id: 25,
  //       label: 'event.event',
  //       link: '/event',
  //       parentId: 24,
  //     },
  //     {
  //       id: 26,
  //       label: 'FAQ',
  //       link: '/faq',
  //       parentId: 24,
  //     },
  //   ],
  // },
  {
    id: 36,
    label: 'terms-conditions.termsPersonal',
    subItems: [
      {
        id: 37,
        label: 'terms-conditions.termsOfUse',
        link: '/terms-conditions',
        parentId: 36,
      },
      {
        id: 38,
        label: 'terms-conditions.termsOfUseEn',
        link: '/terms-en',
        parentId: 36,
      },
      {
        id: 39,
        label: 'personal-info.personalInfo',
        link: '/personal-info',
        parentId: 36,
      },
      {
        id: 40,
        label: 'personal-info.personalInfoEn',
        link: '/personal-en',
        parentId: 40,
      },
    ],
  },
  {
    id: 41,
    label: 'banner.banner',
    link: '/banner',
  },
  {
    id: 42,
    label: 'auto-push.autoPush',
    link: '/auto-push',
  },
];
